import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'
import { subscribe } from 'klaviyo-subscribe'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { listRadio: listRadios = [], listSelect, form, nameInput, emailInput, successMessage, errorMessage } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(listRadios).forEach(radio => {
        radio.addEventListener('change', changeRadio)
    })

    form.addEventListener('submit', submitForm)


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function changeRadio(e) {
        const thisRadio = e.currentTarget
        listSelect.value = thisRadio.value
    }

    function submitForm(e) {
        e.preventDefault()

        const name = nameInput.value
        const email = emailInput.value
        const listId = listSelect.value

        subscribe(listId, email, {
            $first_name: name
        })
        .then(r => {
            if (r.errors.length === 0 && r.data.is_subscribed === false) {
                nameInput.value = ''
                emailInput.value = ''
                errorMessage.style.display = 'none'
                successMessage.style.display = ''
            }
            
            if (r.errors.length > 0) {
                r.errors.forEach(error => {
                    errorMessage.innerText = ''

                    const el = document.createElement('p')
                    el.innerText = error
                    errorMessage.appendChild(el)
                })

                errorMessage.style.display = ''
            }

            if (r.data.is_subscribed)
                errorMessage.style.display = ''
        })
    }
})